"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const antd_1 = require("antd");
const react_router_dom_1 = require("react-router-dom");
const ServicesStyles_1 = require("../ServicesStyles");
const checked_svg_1 = __importDefault(require("../../../../assets/images/checked.svg"));
require("./NewService.scss");
const RoutesPaths_1 = require("../../../../routes/RoutesPaths");
const HTTPService_1 = require("../../../../services/HttpService/HTTPService");
const createAssignement_1 = require("../useCases/createAssignement");
const Properties_1 = require("../../../../hooks/Properties");
const getReserveInfo_1 = require("../useCases/getReserveInfo");
const response_codes_1 = require("../../../../assets/constants/response_codes");
const listAssignmentCodes_1 = require("../useCases/listAssignmentCodes");
const helpers_1 = require("../../../../utils/helpers");
const getReserveInfoByIdAndName_1 = require("../useCases/getReserveInfoByIdAndName");
const message_utils_1 = __importDefault(require("../../../../utils/message_utils"));
const { Option } = antd_1.Select;
const NewService = ({ icon, text }) => {
    var _a, _b, _c, _d;
    const [properties, setProperties] = (0, react_1.useState)([]);
    const [assignmentsCodeList, setAssignmentCodeList] = (0, react_1.useState)([]);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [isModalVisible, setIsModalVisible] = (0, react_1.useState)(false);
    const [isYourProperty, setIsYourProperty] = (0, react_1.useState)(undefined);
    const [isYourRoom, setIsYourRoom] = (0, react_1.useState)(undefined);
    const [maintenanceOrRequests, setMaintenanceOrRequests] = (0, react_1.useState)(undefined);
    const [step, setStep] = (0, react_1.useState)(0);
    const [hasActiveBooking, setHasActiveBooking] = (0, react_1.useState)(true);
    const [form] = antd_1.Form.useForm();
    const [isButtonDisable, setIsButtonDisable] = (0, react_1.useState)(false);
    const user = (0, helpers_1.decryptStorage)('user_data');
    const [reserveInfo, setReserveInfo] = (0, react_1.useState)({});
    const history = (0, react_router_dom_1.useHistory)();
    const propContext = (0, Properties_1.useProperties)();
    const fetchAssignmentCodes = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        const fetchAssignementCodes = new listAssignmentCodes_1.ListAssignmentsCode(new HTTPService_1.HTTPService());
        const assignmentCodes = yield fetchAssignementCodes.run({
            propId: reserveInfo.property.propId.toString(),
            type: maintenanceOrRequests || '',
        });
        setIsLoading(false);
        setAssignmentCodeList(assignmentCodes === null || assignmentCodes === void 0 ? void 0 : assignmentCodes.listTypes);
    }), [maintenanceOrRequests, reserveInfo]);
    const getActiveProperty = (0, react_1.useCallback)(activePropertyId => {
        const property = properties.filter(({ propId }) => propId === activePropertyId);
        return property;
    }, [properties]);
    const formatUnitName = (0, react_1.useCallback)((unitName) => {
        var _a;
        const numberPattern = /\d+/g;
        const [unitNameAndNumber] = unitName.split('|');
        return ((_a = unitNameAndNumber.match(numberPattern)) === null || _a === void 0 ? void 0 : _a.join('')) || '';
    }, []);
    const fetchActiveBooking = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        const fetchBookingInfo = new getReserveInfo_1.GetReserveInfo(new HTTPService_1.HTTPService());
        setIsModalVisible(true);
        setIsLoading(true);
        fetchBookingInfo
            .run()
            .then(bookingInfo => {
            const [property = {}] = getActiveProperty(bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.booking.propId);
            const room = formatUnitName((bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.unitName) || '');
            setReserveInfo({
                bookingId: bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.booking.bookId,
                property: {
                    name: property.name,
                    propId: property.propId,
                },
                room: {
                    roomId: room,
                    roomNum: room,
                },
            });
            setStep(1);
            setIsLoading(false);
        })
            .catch(() => {
            // message.error('Ocorreu um erro ao encontrar a sua reserva. Por favor nos diga onde você esta.');
            setStep(2);
            setHasActiveBooking(false);
            setIsModalVisible(true);
            setIsLoading(false);
        });
    }), [formatUnitName, getActiveProperty]);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if ((propContext === null || propContext === void 0 ? void 0 : propContext.properties) && ((_a = propContext === null || propContext === void 0 ? void 0 : propContext.properties) === null || _a === void 0 ? void 0 : _a.length)) {
            const tempProperties = (_b = propContext.properties) === null || _b === void 0 ? void 0 : _b.map(({ propId, name }) => ({ propId, name }));
            setProperties(tempProperties);
        }
    }, [propContext]);
    (0, react_1.useEffect)(() => {
        if (step === 8)
            history.push(RoutesPaths_1.routesPaths.myAccountRequests);
    }, [step]);
    (0, react_1.useEffect)(() => {
        if (step === 5)
            fetchAssignmentCodes();
    }, [step]);
    const cancelModal = () => {
        setIsModalVisible(false);
        setIsYourProperty(undefined);
        setIsYourRoom(undefined);
        setStep(0);
    };
    const showStepAnimation = (stepNumber) => {
        setStep(stepNumber);
        setTimeout(() => {
            setStep(stepNumber + 1);
        }, 2000);
    };
    const submitPropertyAndRoomForm = () => {
        form.validateFields([['propertyNumber'], ['roomNumber']]).then((values) => __awaiter(void 0, void 0, void 0, function* () {
            const activeProperty = JSON.parse(values.propertyNumber);
            const activeRoom = values.roomNumber;
            const getReserveByIdAndName = new getReserveInfoByIdAndName_1.GetReserveInfoByIdAndName(new HTTPService_1.HTTPService());
            getReserveByIdAndName
                .run({
                unitName: activeRoom,
                propName: activeProperty.name,
            })
                .then(respBooking => {
                if (respBooking.code === response_codes_1.BookingReservationCodes.success.ROOM_FOUNDED) {
                    setReserveInfo({
                        bookingId: respBooking.booking.bookId,
                        property: activeProperty,
                        room: {
                            roomId: activeRoom,
                            roomNum: activeRoom,
                        },
                    });
                    showStepAnimation(3);
                }
            })
                .catch(err => {
                message_utils_1.default.error({
                    message: 'Reserva não encontrada',
                    description: 'Verifique os dados e tente novamente',
                });
            });
        }));
    };
    const submitMaintenanceForm = () => {
        form.validateFields([['maintenanceNumber'], ['maintenanceDescription']]).then((values) => __awaiter(void 0, void 0, void 0, function* () {
            setIsButtonDisable(true);
            const createAssignment = new createAssignement_1.CreateAssignment(new HTTPService_1.HTTPService());
            const { maintenanceDescription, maintenanceNumber } = values;
            const requestParams = {
                id_assignment_code: maintenanceNumber,
                id_booking: reserveInfo.bookingId,
                message: maintenanceDescription,
                type: maintenanceOrRequests || '',
            };
            const response = yield createAssignment.run(requestParams).catch(() => {
                message_utils_1.default.error({
                    message: 'Ocorreu um erro ao realizar a solicitação.',
                    description: 'Tente novamente mais tarde.',
                });
            });
            if ((response === null || response === void 0 ? void 0 : response.code) !== 201) {
                message_utils_1.default.error({
                    message: 'Ocorreu um erro ao realizar a solicitação.',
                    description: 'Tente novamente mais tarde.',
                });
                setStep(5);
            }
            else {
                setStep(7);
                form.resetFields([['maintenanceNumber'], ['maintenanceDescription']]);
            }
            setIsButtonDisable(false);
        }));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "ServiceCard noselect NewService", onClick: fetchActiveBooking },
            react_1.default.createElement("div", { className: "service-icon-container" }, icon),
            react_1.default.createElement("div", { className: "service-name" }, text)),
        react_1.default.createElement(antd_1.Modal, { wrapClassName: "NewService-wrap-modal", title: "Manuten\u00E7\u00E3o e Solicita\u00E7\u00F5es", destroyOnClose: true, visible: isModalVisible, onCancel: cancelModal, footer: [], width: 600, centered: true },
            react_1.default.createElement(antd_1.Spin, { spinning: isLoading, tip: "Carregando..." },
                react_1.default.createElement(antd_1.Form, { className: "modal-container", form: form, noValidate // disable HTML5 validation
                    : true },
                    react_1.default.createElement("div", { style: { display: [0].includes(step) ? 'block' : 'none', height: 400 } }),
                    react_1.default.createElement("div", { className: "step-1", style: { display: [1, 2].includes(step) ? 'block' : 'none' } },
                        react_1.default.createElement("div", { className: "text-container" },
                            react_1.default.createElement("div", { className: "guest-name" },
                                "Ol\u00E1 Sr(a)",
                                react_1.default.createElement("span", null, `${user.firstName},`)),
                            react_1.default.createElement("div", { className: "service-text" }, "Estamos aqui para ajud\u00E1-lo com toda e qualquer solicita\u00E7\u00E3o ou manuten\u00E7\u00E3o, mas primeiro nos ajude a confirmar o local da sua hospedagem e n\u00FAmero do quarto."),
                            react_1.default.createElement("div", { className: "lets-go" }, "Vamos l\u00E1!")),
                        react_1.default.createElement("div", { style: { display: step === 1 ? 'block' : 'none' } },
                            react_1.default.createElement("div", { className: "question-container" },
                                react_1.default.createElement("div", { className: "question" },
                                    react_1.default.createElement("span", null, "Voc\u00EA est\u00E1 hospedado em "),
                                    react_1.default.createElement("b", null, (_a = reserveInfo === null || reserveInfo === void 0 ? void 0 : reserveInfo.property) === null || _a === void 0 ? void 0 : _a.name),
                                    "\u00A0",
                                    react_1.default.createElement("span", null,
                                        "no quarto",
                                        react_1.default.createElement("b", null,
                                            "\u00A0 n\u00B0", (_b = reserveInfo === null || reserveInfo === void 0 ? void 0 : reserveInfo.room) === null || _b === void 0 ? void 0 :
                                            _b.roomNum),
                                        "?")),
                                react_1.default.createElement("div", { className: "answer-container" },
                                    react_1.default.createElement(ServicesStyles_1.ServiceButton, { onClick: () => showStepAnimation(3), className: `${isYourProperty === 'yes' ? 'selected-answer' : ''}` }, "Sim"),
                                    react_1.default.createElement(ServicesStyles_1.ServiceButton, { onClick: () => setStep(2), className: `${isYourProperty === 'no' ? 'selected-answer' : ''}` }, "N\u00E3o"))),
                            react_1.default.createElement("div", { className: "footer-container" },
                                react_1.default.createElement("div", { className: "footer-buttons" },
                                    react_1.default.createElement(ServicesStyles_1.ServiceButton, { onClick: cancelModal }, "Voltar")))),
                        react_1.default.createElement("div", { style: { display: step === 2 ? 'block' : 'none' } },
                            react_1.default.createElement("div", null,
                                react_1.default.createElement(antd_1.Form.Item, { label: "Selecione a su\u00EDte em que est\u00E1 hospedado(a)", labelCol: { span: 24 }, name: "propertyNumber", rules: [{ required: true, message: 'Este campo é obrigatório.' }] },
                                    react_1.default.createElement(antd_1.Select, { style: { minWidth: 80, width: '100%' } }, properties.map(v => (react_1.default.createElement(Option, { key: v.propId, value: JSON.stringify(v) }, v.name))))),
                                react_1.default.createElement(antd_1.Form.Item, { label: "Digite o n\u00FAmero do quarto hospedado(a)", labelCol: { span: 24 }, name: "roomNumber", rules: [
                                        { required: true, message: 'Este campo é obrigatório.' },
                                        { max: 100, message: 'Insira um número válido.' },
                                    ], getValueFromEvent: evt => evt.target.value.replace(/\D/g, '') },
                                    react_1.default.createElement(antd_1.Input, null))),
                            react_1.default.createElement("div", { className: "footer-container" },
                                react_1.default.createElement("div", { className: "footer-buttons" },
                                    react_1.default.createElement(ServicesStyles_1.ServiceButton, { style: { display: hasActiveBooking ? 'inline-block' : 'none' }, onClick: () => setStep(1) }, "Voltar"),
                                    react_1.default.createElement(ServicesStyles_1.ServiceButton, { className: `${isYourRoom === undefined ? '' : 'next-enabled'} active-buttom`, onClick: submitPropertyAndRoomForm }, "Pr\u00F3ximo"))))),
                    react_1.default.createElement("div", { className: "step-2", style: { display: step === 3 ? 'block' : 'none' } },
                        react_1.default.createElement("div", { className: "step-2-container success-message noselect" },
                            react_1.default.createElement("div", { className: "success-title" }, "Obrigado(a)!"),
                            react_1.default.createElement("div", { className: "success-text" }, "J\u00E1 lhe localizamos! "),
                            react_1.default.createElement("img", { className: "success-icon", src: checked_svg_1.default }))),
                    react_1.default.createElement("div", { className: "step-3", style: { display: [4, 5, 6, 7].includes(step) ? 'block' : 'none' } },
                        react_1.default.createElement("div", { className: "step-3-room-container" },
                            react_1.default.createElement("div", { className: "property-name" }, ((_c = reserveInfo === null || reserveInfo === void 0 ? void 0 : reserveInfo.property) === null || _c === void 0 ? void 0 : _c.name) || ''),
                            react_1.default.createElement("div", { className: "room-name" },
                                "Suite 360 - n\u00BA",
                                ((_d = reserveInfo === null || reserveInfo === void 0 ? void 0 : reserveInfo.room) === null || _d === void 0 ? void 0 : _d.roomId) || '')),
                        react_1.default.createElement("div", { style: { display: step === 4 ? 'block' : 'none' } },
                            react_1.default.createElement("div", { className: "question-container" },
                                react_1.default.createElement("div", { className: "question" }, "Como podemos lhe ajudar?"),
                                react_1.default.createElement("div", { className: "answer-container" },
                                    react_1.default.createElement(ServicesStyles_1.ServiceButton, { onClick: () => {
                                            setMaintenanceOrRequests('repair');
                                            setStep(5);
                                        } }, "Manuten\u00E7\u00E3o"),
                                    react_1.default.createElement(ServicesStyles_1.ServiceButton, { onClick: () => {
                                            setMaintenanceOrRequests('task');
                                            setStep(5);
                                        }, className: `${maintenanceOrRequests === 'task' ? 'selected-answer' : ''}` }, "Solicita\u00E7\u00F5es")),
                                react_1.default.createElement("div", { style: { marginBottom: 60 } }))),
                        react_1.default.createElement("div", { className: "maintenance-form", style: { display: step === 5 ? 'block' : 'none' } },
                            react_1.default.createElement(antd_1.Form.Item, { label: `Escolha o tipo de ${maintenanceOrRequests === 'repair' ? 'manutenção' : 'solicitação'}:`, labelCol: { span: 24 }, name: "maintenanceNumber", rules: [{ required: true, message: 'Este campo é obrigatório.' }] },
                                react_1.default.createElement(antd_1.Select, { style: { minWidth: 80, width: '100%' } }, assignmentsCodeList.map(v => (react_1.default.createElement(Option, { key: v.code, value: v.code }, v.name))))),
                            react_1.default.createElement(antd_1.Form.Item, { label: "Descri\u00E7\u00E3o do problema:", labelCol: { span: 24 }, name: "maintenanceDescription", rules: [
                                    { required: true, message: 'Este campo é obrigatório.' },
                                    { max: 300, message: 'Máximo 300 caracteres.' },
                                ] },
                                react_1.default.createElement(antd_1.Input.TextArea, { placeholder: "Escreva aqui o seu pedido de manuten\u00E7\u00E3o", rows: 4 })),
                            react_1.default.createElement("div", { className: "footer-container" },
                                react_1.default.createElement("div", { className: "footer-buttons" },
                                    react_1.default.createElement(ServicesStyles_1.ServiceButton, { disabled: isButtonDisable, onClick: () => {
                                            setStep(4);
                                            form.resetFields([['maintenanceNumber'], ['maintenanceDescription']]);
                                        } }, "Voltar"),
                                    react_1.default.createElement(ServicesStyles_1.ServiceButton, { className: "active-buttom", onClick: submitMaintenanceForm, disabled: isButtonDisable, loading: isButtonDisable }, "Enviar")))),
                        react_1.default.createElement("div", { style: { display: step === 7 ? 'block' : 'none' } },
                            react_1.default.createElement("div", { className: "step-3-success success-message" },
                                react_1.default.createElement("div", { className: "success-title" }, "Realizado com Sucesso!"),
                                react_1.default.createElement("div", { className: "success-text" }, "Estamos trabalhando para resolver o mais r\u00E1pido poss\u00EDvel"),
                                react_1.default.createElement("img", { className: "success-icon", src: checked_svg_1.default }))),
                        react_1.default.createElement("div", { className: "footer-container" },
                            react_1.default.createElement("div", { className: "footer-buttons" },
                                react_1.default.createElement(ServicesStyles_1.ServiceButton, { className: "selected-answer", onClick: cancelModal, disabled: isButtonDisable }, "Fechar")))))))));
};
exports.default = NewService;
